import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import createTheme from "./theme";


export function CustomThemeProvider(props){
    const themeApp = import.meta.env.VITE_APP_PRODUCT === "HOSPITAL" ? createTheme("HOSPITAL") : createTheme("GREEN");
    
    const investigations = useSelector((state) => state.investigations);
    const currentInv = investigations.currentInvestigation;
    const custom = currentInv ? currentInv.aesthetics?.params : null;
    // Only demo investigations preview the panel-configured primary/secondary colour
    // live. Real tenants keep the neutral #666666: their saved primary.color is an
    // accent/logo colour (some are #fff / #000, e.g. CHOM's #e63a39) that breaks the UI
    // as the MUI primary swatch — hence it was hardcoded to #666666 in the first place.
    const previewColors = currentInv?.demo === true;
    if (custom) {
        // Each block is guarded: the Demo Configuration panel only writes
        // primary/secondary/terciary, so header/sidebar/nextButton may be absent —
        // those keep the base theme defaults instead of crashing.
        // The primary/secondary swatch (main + the custom `primary.color` key consumed
        // as an icon/text colour app-wide) stays neutral #666666 for real tenants; only
        // demo investigations preview the configured accent.
        const swatch = (configured) => (previewColors && configured) ? configured : '#666666';
        if (custom.primary) {
            themeApp.palette.background.default = custom.primary.background ?? themeApp.palette.background.default;
            themeApp.header.background = custom.header?.background ?? custom.primary.background ?? themeApp.header.background;
        }
        themeApp.palette.primary.main = swatch(custom.primary?.color);
        themeApp.palette.primary.color = swatch(custom.primary?.color);
        themeApp.palette.secondary.main = swatch(custom.secondary?.color);
        if (custom.sidebar) {
            themeApp.sidebar.background = custom.sidebar.background;
            themeApp.sidebar.color = custom.sidebar.color;
            themeApp.sidebar.header.color = custom.sidebar.color;
            themeApp.sidebar.header.background = custom.sidebar.background;
            themeApp.sidebar.footer.color = custom.sidebar.color;
            themeApp.sidebar.footer.background = custom.sidebar.background;
        }
        if (custom.nextButton) {
            themeApp.buttonContinue.primary.background = custom.nextButton.background;
            themeApp.buttonContinue.primary.color = custom.nextButton.color;
        }
    }

    return (
        
            <MuiThemeProvider theme={themeApp}>
                <ThemeProvider theme={themeApp}>
                    {
                        props.children
                    }
                </ThemeProvider>
            </MuiThemeProvider>
    );
}